module.exports = __webpack_public_path__ + "img/officialSeal_ycjy.9332ec3a.png";